export class UpgradeModal {
  private modal: HTMLElement | null = null;

  show(): void {
    if (this.modal) return;

    this.modal = document.createElement("div");
    this.modal.id = "upgrade-modal";
    this.modal.className =
      "fixed inset-0 z-50 flex items-center justify-center p-4";
    this.modal.style.cssText = "display: flex;";
    this.modal.innerHTML = `
      <div class="absolute inset-0 bg-slate-950/80 backdrop-blur-sm" data-modal-backdrop></div>
      <div class="relative glass p-6 rounded-2xl border border-blue-500/30 bg-slate-900/95 max-w-sm w-full shadow-2xl z-10">
        <button data-modal-close class="absolute top-3 right-3 text-slate-400 hover:text-white transition">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
          </svg>
        </button>
        <div class="text-center">
          <div class="text-4xl mb-3">👑</div>
          <h3 class="text-xl font-bold text-white mb-2">Unlock Unlimited Ranked</h3>
          <p class="text-slate-400 text-sm mb-4">Upgrade to MindRank PRO for unlimited ranked matches and exclusive features.</p>
          <ul class="text-left text-sm text-slate-300 space-y-2 mb-6">
            <li class="flex items-center gap-2">
              <svg class="w-4 h-4 text-emerald-400 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
              </svg>
              Unlimited ranked matches
            </li>
            <li class="flex items-center gap-2">
              <svg class="w-4 h-4 text-emerald-400 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
              </svg>
              Access to all premium tests
            </li>
            <li class="flex items-center gap-2">
              <svg class="w-4 h-4 text-emerald-400 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
              </svg>
              Detailed performance analytics
            </li>
          </ul>
          <button disabled class="w-full bg-yellow-500/50 text-slate-900/70 font-bold py-3 rounded-lg cursor-not-allowed">
            COMING SOON
          </button>
        </div>
      </div>
    `;

    document.body.appendChild(this.modal);
    document.body.style.overflow = "hidden";

    const handleEscape = (e: KeyboardEvent): void => {
      if (e.key === "Escape") {
        this.hide();
        document.removeEventListener("keydown", handleEscape);
      }
    };
    document.addEventListener("keydown", handleEscape);

    this.modal.addEventListener("click", (e) => {
      const target = e.target as HTMLElement;
      if (
        target.closest("[data-modal-close]") ||
        target.closest("[data-modal-backdrop]")
      ) {
        this.hide();
      }
    });
  }

  hide(): void {
    if (!this.modal) return;

    this.modal.remove();
    this.modal = null;
    document.body.style.overflow = "";
  }
}

let upgradeModalInstance: UpgradeModal | null = null;

export function showUpgradeModal(): void {
  if (!upgradeModalInstance) {
    upgradeModalInstance = new UpgradeModal();
  }
  upgradeModalInstance.show();
}
